/* Cursor options for the Inevitrade skin: hover a tile to try its arrow, hover its button for the click state. */

const SHAPE = 'M6 4 L6.6 22 L11.6 17.2 L19.6 16.3 Z';
const glow = (blur: number) => `<filter id='g' x='-50%' y='-50%' width='200%' height='200%'><feGaussianBlur stdDeviation='${blur}'/></filter>`;
const svg = (body: string) => `url("data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'>${body}</svg>`)}") 6 4, auto`;

const M = '#34F5C5';
export const CURSOR_OPTIONS = [
  {
    name: 'A · Solid neon',
    note: 'Filled mint with a soft glow; on click targets the glow brightens.',
    normal: svg(`<defs>${glow(1.4)}</defs><path d='${SHAPE}' fill='${M}' opacity='0.55' filter='url(#g)'/><path d='${SHAPE}' fill='${M}'/>`),
    hover: svg(`<defs>${glow(2.2)}</defs><path d='${SHAPE}' fill='${M}' opacity='0.95' filter='url(#g)'/><path d='${SHAPE}' fill='#B9FFF0'/>`),
  },
  {
    name: 'B · Neon outline',
    note: 'A glowing mint outline, hollow; it fills in over click targets.',
    normal: svg(`<defs>${glow(1.2)}</defs><path d='${SHAPE}' fill='none' stroke='${M}' stroke-width='2' opacity='0.7' filter='url(#g)'/><path d='${SHAPE}' fill='none' stroke='${M}' stroke-width='1.6' stroke-linejoin='round'/>`),
    hover: svg(`<defs>${glow(1.6)}</defs><path d='${SHAPE}' fill='${M}' opacity='0.8' filter='url(#g)'/><path d='${SHAPE}' fill='${M}' stroke='${M}' stroke-width='1.6' stroke-linejoin='round'/>`),
  },
  {
    name: 'C · Glass',
    note: 'Translucent mint body with a bright neon edge; the body lights up over click targets.',
    normal: svg(`<defs>${glow(1.2)}</defs><path d='${SHAPE}' fill='${M}' opacity='0.5' filter='url(#g)'/><path d='${SHAPE}' fill='${M}' fill-opacity='0.25' stroke='${M}' stroke-width='1.4' stroke-linejoin='round'/>`),
    hover: svg(`<defs>${glow(1.8)}</defs><path d='${SHAPE}' fill='${M}' opacity='0.85' filter='url(#g)'/><path d='${SHAPE}' fill='${M}' fill-opacity='0.75' stroke='#D8FFF6' stroke-width='1.4' stroke-linejoin='round'/>`),
  },
  {
    name: 'D · Sharp, no glow',
    note: 'Crisp flat mint, no outline or glow; turns white-hot over click targets.',
    normal: svg(`<path d='${SHAPE}' fill='${M}'/>`),
    hover: svg(`<path d='${SHAPE}' fill='#E6FFF9'/><path d='${SHAPE}' fill='none' stroke='${M}' stroke-width='1.2' stroke-linejoin='round'/>`),
  },
];

export function CursorLab() {
  return (
    <div className="pal-cursor-lab" style={{ minHeight: '100vh', background: 'var(--pal-page)', padding: 32, fontFamily: 'Inter, sans-serif', color: 'var(--pal-text)' }}>
      <h1 className="pal-title" style={{ fontSize: 34, fontWeight: 900, margin: '0 0 6px' }}>CURSOR <span className="pal-em">LAB</span></h1>
      <p style={{ color: 'var(--pal-muted)', marginTop: 0 }}>Hover a tile to try its cursor; hover the button inside for the click state.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16, marginTop: 20 }}>
        {CURSOR_OPTIONS.map(o => (
          <div key={o.name} style={{ cursor: `${o.normal}`, background: 'var(--pal-panel)', boxShadow: 'var(--pal-frame)', borderRadius: 6, padding: 22, minHeight: 240, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontWeight: 800, fontSize: 18 }}>{o.name}</div>
            <div style={{ color: 'var(--pal-muted)', fontSize: 13, lineHeight: 1.5 }}>{o.note}</div>
            <button type="button" style={{ cursor: `${o.hover}`, marginTop: 'auto', padding: '12px 16px', border: 'none', borderRadius: 4, background: 'var(--pal-accent)', color: 'var(--pal-on-accent)', fontWeight: 700 }}>Hover me (click target)</button>
          </div>
        ))}
      </div>
    </div>
  );
}
